import { URSSAF } from '@/utils/logos'

// TODO: gérer les traductions
export const servicePAM = {
	associatedRule: 'dirigeant . indépendant . PL . PAMC',
	url: 'https://www.urssaf.fr/accueil/services/services-independants/service-pam.html',
	title: 'Le service en ligne Praticien ou auxiliaire médical',
	description:
		'L’Urssaf met à votre disposition un service en ligne. Il vous permet de gérer votre activité, contacter un conseiller et retrouver tous vos documents.',
	ctaLabel: 'Accéder au service',
	ariaLabel: 'Accéder au service sur urssaf.fr, nouvelle fenêtre',
	logo: URSSAF,
}
